import { GetString } from 'fluent-react';
import React, { RefObject } from 'react';
import {
  CountryYear,
  Product,
  ProductClass,
  ProductLevel,
  TreeMapInput,
  TreeMapProduct,
  TreeMapType,
} from '../../graphQL/types/shared';
import { gql, useQuery } from '../../graphQL/useQuery';
import { SlideElementProps } from '../../presentationManager/PresentationManager';
import {
  CategoryIconsContainer,
} from '../Grid';
import Legend from './Legend';
import transform from './transform';

const query = gql`
  query CountryProfilesExportComplexityTreeMapLegend(
      $facet: TreeMapType!,
      $productClass: ProductClass,
      $year: Int!,
      $productLevel: ProductLevel,
      $locationLevel: LocationLevel,
      $location: ID!,
      $product: ID,
      $partner: ID,
  ) {
    complexityLegend: treeMap(
      facet: $facet,
      productClass: $productClass,
      year: $year,
      productLevel: $productLevel,
      locationLevel: $locationLevel,
      location: $location,
      product: $product,
      partner: $partner,
      mergePci: true,
    ) {
      ... on TreeMapProduct {
        product {
          id
          type: productType
        }
        pci
        exportValue
        importValue
      }
    }
    location: countryYear(location: $location, year: $year) {
      eci
    }
  }
`;
export interface FetchedDatum {
  product: {
    id: Product['id']
    type: Product['productType'],
  };
  pci: TreeMapProduct['pci'];
  exportValue: number;
  importValue: number;
}
interface SuccessResponse {
  complexityLegend: FetchedDatum[];
  location: {
    eci: CountryYear['eci'];
  };
}

interface Props extends SlideElementProps {
  countryId: string;
  year: number;
  getFluentString: GetString;
  zIndex: number;
  showEci: boolean;
}

const LegendQueryWrapper = React.forwardRef((props: Props, rootElRef: RefObject<HTMLDivElement>) => {
  const {countryId, year, getFluentString, zIndex, showEci} = props;
  const variables: TreeMapInput = {
    facet: TreeMapType.CPY_C,
    productClass: ProductClass.HS,
    year,
    productLevel: ProductLevel.fourDigit,
    locationLevel: null,
    location: countryId,
    product: null,
    partner: null,
  };
  const style: React.CSSProperties = {
    zIndex,
  };

  const {loading, error, data} = useQuery<SuccessResponse, TreeMapInput>(query, {variables});
  let output: React.ReactElement<any> | null;
  if (loading === true) {
    output = null;
  } else if (error !== undefined) {
    output = null;
    console.error(error);
  } else if (data !== undefined) {
    const {complexityLegend, location } = data;
    const {max, min} = transform(complexityLegend);
    const eci = showEci === true ? location.eci : null;
    output = (
      <Legend
        max={max} min={min} eci={eci}
        getFluentString={getFluentString}
      />
    );
  } else {
    output = null;
  }

  return (
    <CategoryIconsContainer style={style} ref={rootElRef}>
      {output}
    </CategoryIconsContainer>
  );
});

export default LegendQueryWrapper;
